"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const primaryButton_1 = __importDefault(require("../primaryButton/primaryButton"));
const text_1 = __importStar(require("../text/text"));
const shareExperienceModals_1 = __importDefault(require("./shareExperienceModals"));
const applyImg = require('../../assets/images/Referal-Lendigo.png');
const ShareExperienceCard = ({ action, message, submessage, buttonTitle, eventName, }) => {
    const [isModalVisible, setIsModalVisible] = (0, react_1.useState)(false);
    const [isAfterModalVisible, setIsAfterModalVisible] = (0, react_1.useState)(false);
    const [reviewNumber, setReviewNumber] = (0, react_1.useState)(0);
    const openModal = () => {
        setIsModalVisible(true);
    };
    const actionLocal = action || openModal;
    const openAfterModal = () => {
        setIsAfterModalVisible(true);
    };
    const closeAfterModal = () => {
        setIsAfterModalVisible(false);
        setIsModalVisible(false);
    };
    const userChosenRating = (choice) => {
        setReviewNumber(choice);
        openAfterModal();
        setIsModalVisible(false);
    };
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(shareExperienceModals_1.default, { closeModal: () => setIsModalVisible(false), closeAfterModal: closeAfterModal, userChosenRating: userChosenRating, isModalVisible: isModalVisible, isAfterModalVisible: isAfterModalVisible, reviewNumber: reviewNumber, eventName: eventName }),
        react_1.default.createElement(react_native_1.Image, { source: applyImg, style: { width: 230, height: 170, resizeMode: 'cover' } }),
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE }, message),
                submessage && react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, submessage)),
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(primaryButton_1.default, { disabled: false, title: buttonTitle, onPress: actionLocal, eventName: "go_to_Survey" })))));
};
ShareExperienceCard.defaultProps = {
    action: undefined,
    submessage: undefined,
};
exports.default = ShareExperienceCard;
